export function FooterBorder(props) {
  return (
    <svg
      width="375"
      height="8"
      viewBox="0 0 375 8"
      preserveAspectRatio="none"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H0.164716H375V6.28571L355.27 5.2032L338.199 6.12209L314.805 3.54622L291.315 5.2032L277.211 3.54622L264.292 6.12185L236.687 5.2032L209.084 3.99872L185.721 7.02598C185.721 7.02598 174.471 4.80974 169.5 4.80974C164.529 4.80974 162 7.02598 158.129 7.02598C154.259 7.02598 132.546 3.13076 132.546 3.13076L108.374 3.99872H85.715L41.9195 8L15.8503 5.2032L0 6.28571V0Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  )
}
